import { NumberField } from 'Shared/forms/Inputs';
import { LabelOnLeftWrap } from 'Shared/forms/Wrap';

export function ShowForegroundOnTimer()
{
	const style = {
		display: 'flex',
		gap: '0.5em',
	};

	return (
		<div style={style}>
			<LabelOnLeftWrap label='Group size' narrow={true}>
				<NumberField field='groupSize' />
			</LabelOnLeftWrap>
			<LabelOnLeftWrap label='Cycle time' narrow={true}>
				<NumberField field='cycleTime' />
			</LabelOnLeftWrap>
			<LabelOnLeftWrap label='Start position' narrow={true}>
				<NumberField field='startingPosition' />
			</LabelOnLeftWrap>
		</div>
	);
}

